import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import shared from '@/micro/shared'
import { computed, ref } from 'vue'
import DrawerNav from '@/layout/AppNavDrawer/DrawerNav.vue'
import type { ResourcesChildrenTree } from '@y/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const visible = ref<boolean>(false)
const appMenus = computed(() => {
  const routers = shared.getRouters()
  const navRouters: ResourcesChildrenTree[] = []
  routers?.children &&
    routers.children.forEach(app => {
      if (app.urlPath !== `/${appName.value}`) {
        navRouters.push(app)
      }
    })
  return navRouters
})

const appName = computed(() => shared.getAppName())

const handleClickNav = () => {
  visible.value = !visible.value
}

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "y-nav",
      onClick: handleClickNav
    }, " 快捷导航 "),
    _createVNode(_component_el_drawer, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      title: "快捷导航",
      size: 320
    }, {
      default: _withCtx(() => [
        _createVNode(DrawerNav, {
          menus: appMenus.value,
          onCall: handleClickNav
        }, null, 8, ["menus"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})